import { BarcodeDetectorAdapter } from '../adapters/BarcodeDetectorAdapter.js';
import { normalizeError } from '../utils/errors.js';

export class AdapterManager {
    constructor({ logger, windowLike = globalThis.window } = {}) {
        this.logger = logger;
        this.window = windowLike;
    }

    getCandidates(nativeRuntimeFailures) {
        const candidates = [];
        const nativeSupported = BarcodeDetectorAdapter.isSupported(this.window);

        if (nativeSupported && nativeRuntimeFailures === 0) {
            candidates.push({
                name: 'BarcodeDetector',
                create: async () => new BarcodeDetectorAdapter({
                    logger: this.logger,
                    windowLike: this.window,
                }),
            });
        } else if (!nativeSupported) {
            this.logger.info(
                'adapter.barcode_detector.unavailable',
                'BarcodeDetector não suportado; o fallback ZXing será usado.'
            );
        } else {
            this.logger.warn(
                'adapter.barcode_detector.bypassed',
                'BarcodeDetector apresentou falha em execução; alternando para ZXing.'
            );
        }

        candidates.push({
            name: 'ZXing',
            create: async () => {
                const { ZXingAdapter } = await import(
                    '../adapters/ZXingAdapter.js'
                );

                return new ZXingAdapter({ logger: this.logger });
            },
        });

        return candidates;
    }

    async start({
        stream,
        video,
        nativeRuntimeFailures,
        onDetected,
        onFrame,
        onError,
        onStartupError,
        processingFrameRate,
    }) {
        let lastError = null;

        for (const candidate of this.getCandidates(nativeRuntimeFailures)) {
            let adapter = null;

            try {
                adapter = await candidate.create();
                const details = await adapter.start({
                    stream,
                    video,
                    onDetected,
                    onFrame,
                    onError,
                    processingFrameRate,
                });

                return {
                    adapter,
                    name: adapter.name,
                    details,
                };
            } catch (error) {
                adapter?.stop();
                lastError = normalizeError(
                    error,
                    `adapter.${candidate.name}`
                );
                onStartupError?.(lastError, candidate.name);

                if (candidate.name === 'BarcodeDetector') {
                    this.logger.warn(
                        'adapter.fallback',
                        'Alternando automaticamente de BarcodeDetector para ZXing.'
                    );
                }
            }
        }

        throw lastError;
    }
}
